import React, { useCallback, useEffect, useState } from 'react';
import AppLayout from '../../../../component/appLayout';
import { getProfileSettingData, updateEmailData } from '../../../../services/settingServices';
import { Details, FormBlock, Group, PersonalText, Header, Container } from '../../styles';
import Button from '../../../../component/button';
import { captureException } from '../../../../services/logService';
import { useMobileDevice } from '../../../../global/useMobile';
import ResponsiveHeader from '../../../../component/responsiveHeader';
import BottomSubNavigation from '../../../../component/bottomNavigation/subNavigation';
import { BUTTON_TYPE } from '../../../../global/constants';
import { rootStore } from '../../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import Input from '../../../../component/input';

const Email: React.FC = () => {
  // States
  const [loading, setLoading] = useState(false);
  //Mobx store variables
  const { settingStore } = rootStore;
  const { profileData } = settingStore;
  const isMobile = useMobileDevice();
  const [password, setPassword] = useState('');

  // Loads profile settings data from the server
  const loadData = useCallback(async () => {
    await getProfileSettingData();
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  // Handles form submission and updates email
  const onClicksave = useCallback(
    async (e: React.SyntheticEvent) => {
      try {
        e.preventDefault();
        setLoading(true);
        const payload = { email: profileData?.email, password };
        const result = await updateEmailData(payload);
        if (result) {
          rootStore.settingStore.updateProfileData('email', '');
          loadData();
        }
      } catch (error) {
        captureException(error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    },
    [loadData, password, profileData?.email]
  );

  return (
    <>
      <AppLayout>
        <Container className='desktop-content'>
          <Group as='form' onSubmit={onClicksave} isMiddleContainer={true}>
            {!isMobile ? (
              <Header>
                <PersonalText>Change your Email</PersonalText>
              </Header>
            ) : (
              <ResponsiveHeader title='Change your Email' />
            )}
            <Details>
              <FormBlock>
                <Input
                  label='Email'
                  type='email'
                  value={profileData?.email}
                  onChange={(e) => rootStore.settingStore.updateProfileData('email', e.target.value)}
                  fieldWrapperWidth={isMobile ? '100%' : '260px'}
                />
                <Input
                  label='Password'
                  type='password'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  fieldWrapperWidth={isMobile ? '100%' : '260px'}
                />
              </FormBlock>
              <Button
                title='Change Email'
                variant={BUTTON_TYPE.PRIMARY}
                buttonType='submit'
                isLoading={loading}
                disabled={loading}
              />
            </Details>
          </Group>
        </Container>
      </AppLayout>
      <BottomSubNavigation />
    </>
  );
};
export default observer(Email);
